import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ApiService } from 'src/app/Services/api.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'app-view-parking',
  templateUrl: './view-parking.component.html',
  styleUrls: ['./view-parking.component.css']
})
export class ViewParkingComponent implements OnInit {

  parkingInformation:any=[];
  public branchInformation=[];
  public searchInput: any = new Subject<string>();
  public searchedValue: any="";
  public serchKey:String="title";
  noDataEnable: boolean = false;
  public orgID;
  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
    public swal: SweetAlert) {
      this.orgID= this.storage.get('userInfo').orgID;
     }

  ngOnInit(): void {
    this.getParkingList();
    this.getBranchList();
  }
  /* API */
  getParkingList() {
    const obj = {
      orgID: this.orgID
    };
    this.api.transportManagerParkingList(obj).then((res: any) => {
      console.log(res);
      if (res.status == 'success') {
        this.parkingInformation = res.data;
        this.noDataEnable=true;
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getBranchList() {
    const obj = {
      orgID: this.orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      console.log(res);
      if (res.status == 'success') {
        this.branchInformation = res.data;
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  getBranchName(id){
    let name='';
    this.branchInformation.filter((e)=>{
    if(e.branchID==id){
      name=e.branchName;
    }  
    });
    return name;
  }

  editParkingData(data){
    this.router.navigate(['/organization/transport-manager/information/orgInfo/parking/edit-parking',data.parkingID]);
  }
}
